import { gql } from '@apollo/client';

export const ALL_ORGANISATIONS = gql`
  query AllOrganisations($input: OrganisationFilterArgs!) {
    organisations: getOrganisations(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id

          isFunder
          isInstitution
          isServiceProvider

          funder {
            id
            name
          }
          institution {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
      }
    }
  }
`;
